// eslint-disable-next-line prettier/prettier
import {
  AuthService,
  // requests
  EmailAvailabilityOptions,
  // responses
} from '@digital-advice/ms-auth-sdk';
import {apiKey, getLogger, resolveEndpointForServiceToken, interceptors, sourceInfo} from '@advisor/services/sdk';

interface AuthServiceOptions {
  hasServiceTokenEndpoint?: boolean;
}

export const defaultOptions: AuthServiceOptions = {
  hasServiceTokenEndpoint: false,
};

export default class AuthServices {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static async sdkService(options: AuthServiceOptions = defaultOptions) {
    const service = await new AuthService({
      logger: getLogger(),
      apiKey,
      endpoint: resolveEndpointForServiceToken(options.hasServiceTokenEndpoint),
      interceptors,
      sourceInfo,
    });

    return service;
  }

  /**
   * Gateway endpoint: isEmailAvailable
   * @param {Object} {riaId}
   */
  static async isEmailAvailable(payload: EmailAvailabilityOptions): Promise<boolean> {
    const serviceOptions: AuthServiceOptions = {
      hasServiceTokenEndpoint: false,
    };
    const advService = await this.sdkService(serviceOptions);

    return advService.isEmailAvailable(payload);
  }
}
